import styled from "styled-components";
import PublicSelect from "../../publics/PublicSelect";
import { CLOUDN_COLORS } from "../../../constants/colors";
import { AllDeviceSelectBoxProps } from "../../../constants/types";
import { SelectChangeEvent } from "@mui/material";
import { getSiteSelectList, types } from "../../../constants/function";

const AllDeviceSelectBox = (props: AllDeviceSelectBoxProps) => {
  const onChangeSiteNo = (e: SelectChangeEvent) => {
    props.option.setOptions({
      ...props.option.options,
      siteNo: e.target.value,
    });
  };
  const onChangeType = (e: SelectChangeEvent) => {
    props.option.setOptions({
      ...props.option.options,
      type: e.target.value,
    });
  };
  return (
    <Container>
      <PublicSelect
        height={100}
        items={getSiteSelectList(props.categories)}
        onChange={onChangeSiteNo}
        value={props.option.options.siteNo}
        width={30}
        placeholder="프로젝트 선택"
        name="siteNo"
        all
      />
      <PublicSelect
        height={100}
        items={types}
        onChange={onChangeType}
        value={props.option.options.type}
        width={30}
        placeholder="기기 선택"
        margin="0 0 0 2%"
        name="type"
        all
      />
    </Container>
  );
};

export default AllDeviceSelectBox;

const Container = styled.div`
  width: 100%;
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const Button = styled.div`
  width: 8%;
  height: 90%;
  border-radius: 5px;
  background-color: ${CLOUDN_COLORS.logoBlue};
  color: white;
  font-size: 0.8vw;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  cursor: pointer;

  &:hover {
    background-color: ${CLOUDN_COLORS.logoSkyBlue};
  }
`;
